function LoadingSpinner({ label = "Loading..." }) {
  return (
    <div className="flex items-center justify-center gap-3 text-sm text-emerald-700">
      <span className="h-5 w-5 animate-spin rounded-full border-2 border-emerald-200 border-t-emerald-600" />
      <span>{label}</span>
    </div>
  );
}

export default LoadingSpinner;
